import { render, staticRenderFns } from "./tendersListItem.vue?vue&type=template&id=4125e138&scoped=true&"
import script from "./tendersListItem.vue?vue&type=script&lang=js&"
export * from "./tendersListItem.vue?vue&type=script&lang=js&"
import style0 from "./tendersListItem.vue?vue&type=style&index=0&id=4125e138&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4125e138",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4125e138')) {
      api.createRecord('4125e138', component.options)
    } else {
      api.reload('4125e138', component.options)
    }
    module.hot.accept("./tendersListItem.vue?vue&type=template&id=4125e138&scoped=true&", function () {
      api.rerender('4125e138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/tenders/tendersListItem.vue"
export default component.exports